// packages
import { timeDay } from 'd3-time';
import { format } from 'd3-format';
import { apmonth, apdate } from 'journalize';
import { timeParse } from 'd3-time-format';

// local
import { esmonth } from './esmonth';

export const locale = document.documentElement.lang;

export const dateParser = timeParse('%Y-%m-%d');
export const pctFormat = format(`.0%`);

export function dateFormat(d) {
  return `${monthFormat(d)} ${d.getDate()}`;
}

export function monthFormat(d) {
  switch (locale) {
    case 'en':
      return apmonth(d);
    case 'es':
      return esmonth(d);
    default:
      throw new Error(`"${locale}" is not a valid formatting string`);
  }
}

export function apMonthFormat(d, i) {
  let month = d.getMonth();
  if (i == 0) {
    return apdate(d);
  } else if (month == 0 || month == 1) {
    return apdate(d);
  } else {
    return apmonth(d);
  }
}

export function dateFilter(d) {
  const day = d.getDate();
  return day === 1;
}

export function monthTrimmer(a, minTickLabels = 2, maxTickLabels = 6) {
  if (a.length <= 2) {
    return a;
  } else if (a.length <= maxTickLabels) {
    return a;
  }
  return monthTrimmer(
    a.filter((d, i) => i % 2 == 0),
    maxTickLabels
  );
}

export function monthTickValues(startDate, endDate) {
  const dateRange = timeDay.range(startDate, endDate);
  const monthRange = dateRange.filter(dateFilter);
  return monthTrimmer(monthRange);
}

export function numberFormat(num, digits) {
  var si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
}
